import React, {useState, useEffect, useRef}  from "react";
import {Marker, Polyline, Popup, useMap} from "react-leaflet";
import L from "leaflet";
import { popupContent, popupHead, popupText, okText } from "../popupStyles";
import Moment from 'react-moment';
import 'leaflet-rotatedmarker';

export default function UserObject(props) {
    
    const position = [props.sessione.latitude, props.sessione.longitude];
    const email = props.sessione.email;

    const generalRelIcon = L.icon({
        iconUrl: './icons/iconaUomo.png',
        iconSize: new L.point(46, 46),
        iconAnchor: [19, 19],
    });

    const iconaCanadair = L.icon({
        iconUrl: './icons/CANADAIR.png',
        iconSize: new L.point(46, 46),
        iconAnchor: [19, 19],
    });

    const iconaDos = L.icon({
        iconUrl: './icons/DOS.png',
        iconSize: new L.point(46, 46),
        iconAnchor: [19, 19],
    });

    const iconaPca = L.icon({
        iconUrl: './icons/PCA.png',
        iconSize: new L.point(46, 46),
        iconAnchor: [19, 19],
    });

    const getIconForEmail = (email) => {
        switch(email) {
            case 'black-gigi@live.it':
            case 'can26@fly4data.it':
            // case 'black-gigi@live.it':
            case 'can07@fly4data.it':
                return iconaCanadair;
            case 'dos1@fly4data.it':
                return iconaDos;
            case 'pca1@fly4data.it':
                return iconaPca;
            default:
                return generalRelIcon;
        }
    };

    const selectedIcon = getIconForEmail(email);
    
    return (
        <Marker position={position} icon={selectedIcon}>
            <Popup>
                <div>
                    <div>
                        Latitude: {props.sessione.latitude}
                    </div>
                    <div>
                        Longitude: {props.sessione.longitude}
                    </div>
                    <div>
                        {/*Detected at: <Moment format= "HH:mm:ss">{sessione.timestamp}</Moment>*/}
                    </div>
                    <div>
                        {email}
                    </div>
                </div>
            </Popup>
        </Marker>
    );


}